import axios from "axios";
import { parseApiData } from "go-core/api/parseApiData";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { restSecurityApi } from "../api";
import { NumberOrderApi, NumberOrderOrganizationInfoApi, OrderData, OrderTransactionApi, PayOrderData } from "./types";

const restPublicApi = axios.create({
	withCredentials: true,
});

class apiPublic {
	static getOrderData = (orderId: string): Promise<OrderData | undefined> => {
		return parseApiData(restSecurityApi.get(`/orders/${orderId}`));
	};

	static sendEmail = (orderId: string, email: string): Promise<void> => {
		return restSecurityApi.post(`/orders/${orderId}/send_public_link_via_mail`, { email });
	};

	static getEReceipt = (orderId: string) => {
		return restSecurityApi.get(`/orders/${orderId}/ereceipt`, { responseType: "blob" });
	};

	static getInvoice = (orderId: string) => {
		return restSecurityApi.get(`/invoices/${orderId}/pdf`, { responseType: "blob" });
	};

	static async getOrderNumbers(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<NumberOrderApi[]> {
		return parseApiData(
			restSecurityApi.get(`order_numbers`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	}

	static async getOrderNumbersOrganizationInfo(
		organizationId: number,
		params?: Record<string, any>,
		options?: Record<string, any>
	): Promise<NumberOrderOrganizationInfoApi> {
		const f = btoa(
			unescape(encodeURIComponent(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}organization_id=${organizationId}`))
		);
		return parseApiData(
			restSecurityApi.get(`order_numbers/info`, {
				params: {
					...params,
					f,
				},
				cancelToken: options?.cancelToken,
			})
		);
	}

	static payOrder = (orderId: string, data: PayOrderData): Promise<OrderTransactionApi> => {
		return parseApiData(restSecurityApi.post(`/orders/${orderId}/transactions`, data));
	};

	static getOrderTransaction = (id: string): Promise<OrderTransactionApi> => {
		return parseApiData(restSecurityApi.get(`/transactions/${id}`));
	};

	static getApplePaySession = (
		orderId: string,
		data: {
			validationUrl: string;
			paymentMethodId: number;
			domainName: string;
			displayName: string;
		}
	): Promise<{ session: string }> => {
		return parseApiData(
			restSecurityApi.post(`/orders/${orderId}/apple_pay_session`, {
				validation_url: data.validationUrl,
				payment_method_id: data.paymentMethodId,
				domain_name: data.domainName,
				display_name: data.displayName,
			})
		);
	};
}

export { apiPublic, restPublicApi };
